import { memo, useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { useOverlayContext } from '../../../context/overlayContext';
import { Search } from '../../../icons';
import { SearchContainer } from './SearchBar.styles';

export type SearchBarProps = {
  forDesktop?: boolean;
  idPrefix?: string;
  className?: string;
};

export function SearchBar({ forDesktop, idPrefix, className }: SearchBarProps) {
  const { t } = useTranslation(['lib-global-common']);
  const searchInputRef = useRef<HTMLButtonElement>(null);

  const { isSearchOverlayOpen, setIsSearchOverlayOpen, searchQuery } = useOverlayContext();

  const handleSearchIconClick = useCallback(() => {
    setIsSearchOverlayOpen((prev) => !prev);
  }, [setIsSearchOverlayOpen]);

  useEffect(() => {
    if (!isSearchOverlayOpen) searchInputRef.current?.focus();
  }, [isSearchOverlayOpen]);

  return (
    <SearchContainer $forDesktop={forDesktop} className={className} $isSearchBarActive={isSearchOverlayOpen}>
      <form role="search" aria-label={t('search.placeholder')}>
        <button
          ref={searchInputRef}
          aria-label={t('search.placeholder')}
          id={`${idPrefix}-search-button`}
          type="button"
          className={searchQuery?.length === 0 ? 'active' : 'inactive'}
          onClick={handleSearchIconClick}
          data-testid="searchButtonDesktop"
        >
          <Search aria-hidden alt="" />
        </button>
        <input
          id="search-input"
          type="search"
          placeholder={t('search.placeholder')}
          value={searchQuery}
          readOnly
          aria-label={t('search.placeholder')}
          tabIndex={-1}
        />
      </form>
    </SearchContainer>
  );
}

export default memo(SearchBar);
